var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath1Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 77,
    viewBox: "0 0 63 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5728 37.3393C65.8464 53.2555 56.8023 69.8669 40.8794 74.8677C24.5343 80.001 6.99696 70.5116 2.01999 54.6642C1.35476 52.546 -0.0128291 48.3247 0.930626 40.1817C1.49524 35.3084 1.848 32.2475 1.75214 29.5809C1.69935 28.1153 1.74753 25.7455 4.90058 28.5921C6.75976 30.2705 7.73682 33.2175 7.73682 33.2175C7.73682 33.2175 11.1643 28.3504 12.1394 20.8025C13.5688 9.73741 8.19286 5.07975 5.71418 1.44527C4.85653 0.18802 3.80777 -2.22621 7.03111 -2.07117C10.3156 -1.91293 19.8055 1.07348 25.6724 5.52007C34.0455 11.8663 38.5697 19.0523 38.5697 19.0523C38.5697 19.0523 39.7068 16.1681 39.6102 13.5542C39.5012 10.6024 38.6668 7.90712 41.97 10.0553C45.1113 12.0982 50.118 16.2188 53.5672 20.548C59.8303 28.4098 61.5728 37.3393 61.5728 37.3393Z",
    fill: "#50402C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1Dark);
export default __webpack_public_path__ + "static/media/path-1_dark.598e95f771e725e6fcf70de545321c7f.svg";
export { ForwardRef as ReactComponent };